// Colors inspired by https://build-app.jp/

// Primary colors
export const primary = {
  main: '#0047BA', // BuildApp primary blue
  light: '#4F73D9',
  dark: '#00348B',
  contrastText: '#FFFFFF',
};

// Secondary colors
export const secondary = {
  main: '#00B67A', // BuildApp secondary green
  light: '#4CD9A9',
  dark: '#00844F',
  contrastText: '#FFFFFF',
};

// Accent colors
export const accent = {
  orange: '#FF6B00',
  yellow: '#FFB800',
  lightBlue: '#00A5E0',
  purple: '#8A4DD3',
};

// Text colors
export const text = {
  primary: '#1A1A1A',
  secondary: '#6B7280',
  disabled: '#9CA3AF',
};

// Background colors
export const background = {
  default: '#FFFFFF',
  paper: '#F9FAFB',
  light: '#F3F4F6',
  dark: '#E5E7EB',
};

// Error, warning, info, success colors
export const error = {
  main: '#DC2626',
  light: '#EF4444',
  dark: '#B91C1C',
  contrastText: '#FFFFFF',
};

export const warning = {
  main: '#F59E0B',
  light: '#FBBF24',
  dark: '#D97706',
  contrastText: '#FFFFFF',
};

export const info = {
  main: '#2563EB',
  light: '#3B82F6',
  dark: '#1D4ED8',
  contrastText: '#FFFFFF',
};

export const success = {
  main: '#059669',
  light: '#10B981',
  dark: '#047857',
  contrastText: '#FFFFFF',
};

// Divider color
export const divider = 'rgba(0, 0, 0, 0.12)';

// Common colors
export const common = {
  black: '#000000',
  white: '#FFFFFF',
};

// Extended grey palette
export const grey = {
  50: '#F9FAFB',
  100: '#F3F4F6',
  200: '#E5E7EB',
  300: '#D1D5DB',
  400: '#9CA3AF',
  500: '#6B7280',
  600: '#4B5563',
  700: '#374151',
  800: '#1F2937',
  900: '#111827',
};
